export default __webpack_public_path__ + "static/media/icon_test_coding_blue.e2b8826e.svg";